import { render } from "./Treat.vue?vue&type=template&id=8dab2bea"
import script from "./Treat.vue?vue&type=script&lang=js"
export * from "./Treat.vue?vue&type=script&lang=js"

import "./Treat.vue?vue&type=style&index=0&id=8dab2bea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__